import { PagePlaceholder } from "../page-placeholder/page-placeholder";

export function Trials(): JSX.Element {
  return <PagePlaceholder title="Trials" />;
}
